"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
exports.__esModule = true;
var styles = ["@media screen and (width:1024px) and (max-height:620px){.keyboard-active[_ngcontent-%COMP%]   .loading-screen-spinner[_ngcontent-%COMP%]{font-size:28px!important}.keyboard-active[_ngcontent-%COMP%]   .loading-screen-spinner[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform-origin:center;transform-box:fill-box}.keyboard-active[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:48px!important}}"];
exports.styles = styles;
